import {Entry} from './Entry';

export class Schedule {
    entries: Entry[];
}
